import React from "react";

type SplunkProps = {
  size?: string;
};

const Splunk = ({ size = "32px" }: SplunkProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <path
        d="M25.904 13.9957V18.0686L6 28V23.6188L21.4247 16L6 8.4839V4L25.904 13.9957Z"
        fill="#0C1724"
      />
    </svg>
  );
};

export default Splunk;
